<script setup>
import {computed, watch} from 'vue'
import {useItemDataStore} from '@/stores/itemData'
import {useFormStore} from '@/stores/form'
import FormControlTypeRelationshipOneToMany from '@/common/form-control-type/FormControlTypeRelationshipOneToMany'

const props = defineProps({
    formId: String,
    field: Object,
    currentData: Object,
    value: Number
})

const itemDataStore = useItemDataStore()
const formStore = useFormStore(props.formId)

// --- Computed ---
const itemId = computed(() => props.currentData.id || 0)

// --- Watcher ---
watch(() => props.value, (newCourseDateId) => {
    if (
        !itemId.value &&
        newCourseDateId
    ) {
        itemDataStore.get({
                tableName: 'odp_course_dates',
                id: newCourseDateId
            })
            .then((obj) => {
                formStore.set({
                    name: 'agreedPrice',
                    value: obj.price,
                })
            })
    }
})
</script>

<template>
    <FormControlTypeRelationshipOneToMany
        :current-data="currentData"
        :field="field"
        :form-id="formId"
    />
</template>